define('SC.ManorThemeExtension.Shopping', [
  'SC.ManorThemeExtension.ApplicationSkeleton.Layout',
  'SC.ManorThemeExtension.Header',
  'SC.ManorThemeExtension.Footer',
  'SC.ManorThemeExtension.Home',
  'SC.ManorThemeExtension.HomeCMS',
  'SC.ManorThemeExtension.ErrorManagement.PageNotFound.View',
  'SC.ManorThemeExtension.Categories.Thumbnail',
  'SC.ManorThemeExtension.ItemRelations.SC.Configuration',
  'SC.ManorThemeExtension.LoadWebFont',
  'SC.ManorThemeExtension.Common.Configuration',
  'SC.ManorThemeExtension.Common.LayoutHelper',
  'SC.ManorThemeExtension.Common.UtilitiesHelper',
  'Utils',
  'underscore'
], function horizonThemeExtensionShoppingEntryPoint(
  ManorThemeApplicationLayout,
  ManorThemeExtHeader,
  ManorThemeExtFooter,
  ManorThemeExtHome,
  ManorThemeExtHomeCMS,
  ManorThemeExtErrorManagementPageNotFoundView,
  ManorThemeExtCategoriesThumbnail,
  ManorThemeExtItemRelations,
  ManorThemeExtLoadWebFont,
  Configuration,
  LayoutHelper,
  UtilitiesHelper,
  Utils,
  _
) {
  'use strict';

  return {
    mountToApp: function (container) {
      UtilitiesHelper.toggleViewportToMobileSupport();
      Configuration.setEnvironment(container.getComponent('Environment'));
      LayoutHelper.setLayoutComponent(container.getComponent('Layout'));
      ManorThemeApplicationLayout.loadModule();
      this.overwriteBxSliderInitialization();
      ManorThemeExtHeader.loadModule();
      ManorThemeExtFooter.loadModule();
      ManorThemeExtHome.loadModule();
      ManorThemeExtHomeCMS.mountToApp(container);
      ManorThemeExtErrorManagementPageNotFoundView.loadModule();
      ManorThemeExtItemRelations.loadModule();
      ManorThemeExtLoadWebFont.loadModule();
    },
    overwriteBxSliderInitialization: function () {
      Utils.initBxSlider = _.initBxSlider = _.wrap(
        _.initBxSlider,
        function initBxSlider(fn) {
          var autoPlayCarousel = Configuration.get('home.autoPlayCarousel');
          var carouselSpeed = Configuration.get('home.carouselSpeed');

          if (
            arguments.length !== 0 &&
            arguments[1] &&
            arguments[1][0] &&
            arguments[1][0].id === 'home-image-slider-list'
          ) {
            arguments[2] = _.extend(arguments[2], {
              auto: autoPlayCarousel,
              pause: carouselSpeed
            });
          }

          return fn.apply(this, _.toArray(arguments).slice(1));
        }
      );
    }
  };
});
